module.exports = __webpack_public_path__ + "img/mv.aca2d307.svg";